import { Helmet } from 'react-helmet-async';
import { MetaType } from '@/types/MetaDTO';
import { Outlet } from 'react-router-dom';
import { useGetMetaDataQuery } from '@/services/api/metaApiSlice';
import React, { FC, ReactElement } from 'react';

export const MainCardPage: FC = (): ReactElement => {
  const { data: meta } = useGetMetaDataQuery(MetaType.CARD);

  return (
    <>
      {meta && (
        <Helmet>
          <title>{meta.title}</title>
          <meta name={'description'} content={meta.description} />
          <meta name={'keywords'} content={meta.keywords} />
        </Helmet>
      )}
      <Outlet />
    </>
  );
};
